import { isRejectedWithValue, isRejected } from "@reduxjs/toolkit";
import { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";

export const httpErrorMiddleware =
  ({ getState, dispatch }) =>
  (next) =>
  (action) => {
    if (isRejected(action)) {
      if (action.error?.message === "401: Unauthorized") {
        const event = new CustomEvent("logoutHandler", {
          detail: new Date().toISOString,
        });
        window.dispatchEvent(event);
      }
    }

    return next(action);
};
